import { render, staticRenderFns } from "./EditPrivilegeGroup.vue?vue&type=template&id=2aafa4b0"
import script from "./EditPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./EditPrivilegeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports